// utils/rem.js
(function initRem() {
  // 设计稿尺寸和基准值
  const designWidth = 1920
  const designHeight = 1080
  const baseFontSize = 16
  
  function setRem() {
    const clientWidth = document.documentElement.clientWidth
    const clientHeight = document.documentElement.clientHeight
    
    // 根据宽度计算（常用）
    const scaleWidth = clientWidth / designWidth
    
    // 或者根据高度计算（适用于高度重要的情况）
    // const scaleHeight = clientHeight / designHeight
    
    // 使用更合适的缩放比例
    const scale = scaleWidth
    
    // 计算字体大小，并限制范围
    let fontSize = baseFontSize * scale
    fontSize = Math.max(12, Math.min(fontSize, 32)) // 限制在12px-32px之间
    
    // 设置根字体大小
    document.documentElement.style.fontSize = fontSize + 'px'
    
    // 同时设置一个自定义属性，方便CSS使用
    document.documentElement.style.setProperty('--scale', scale)
  }
  
  // 初始化
  setRem()
  
  // 防抖函数，避免频繁触发
  let remTimeout
  function debounceSetRem() {
    clearTimeout(remTimeout)
    remTimeout = setTimeout(setRem, 300)
  }
  
  // 监听窗口变化
  window.addEventListener('resize', debounceSetRem)
  
  // 监听页面显示（解决浏览器后退时字体大小问题）
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      debounceSetRem()
    }
  })
  
  // 监听DOMContentLoaded
  document.addEventListener('DOMContentLoaded', setRem)
  
  // 导出函数，方便手动调用
  window.$setRem = setRem
})()